// extracted by mini-css-extract-plugin
module.exports = {"crossedOutPrice":"CartProductPrice_crossedOutPrice__3iOZ9","price":"CartProductPrice_price__33RnC","highlighted":"CartProductPrice_highlighted__39K2j"};